import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import ListingBlock from '@/app/components/listing/ListingBlock.vue'

import type { ListView } from '@/models/docs.list'


export default /*@__PURE__*/_defineComponent({
  __name: 'CollectionsBlock',
  props: {
    view: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (__props.view.dataLength)
    ? (_openBlock(), _createBlock(ListingBlock, {
        key: 0,
        view: __props.view,
        docs: __props.view.docs().filteredDocs.slice(0, 3)
      }, null, 8, ["view", "docs"]))
    : _createCommentVNode("", true)
}
}

})